import ProcMgr from "../stores/ProcMgr";
export default class Commands {
    // class Commands {
    constructor() {
        this.TerminalCommandList = [
            "cd",
            "pwd",
            "echo",
            "clear",
            "help",
            "get",
            "whoami",
            "ls",
            "mkdir",
            "cat",
            "touch",
            "rm",
            "mv",
            "cp",
            "whoami",
            "exit",
            "quit",
            "ps",
            "maximize",
        ];
        this.possibleCommands = [
            ...Commands.ProcMgrCommandList,
            ...this.TerminalCommandList,
        ];
    }
    validateCommand(cmd) {
        return this.possibleCommands.includes(cmd);
    }
    autoCompleteCommand(cmd, from) {
        if (!from) {
            from = this.possibleCommands;
        }
        return from.filter((_cmd) => _cmd.startsWith(cmd));
    }
    destination(cmd) {
        if (this.TerminalCommandList.includes(cmd)) {
            return "terminal";
        }
        if (Commands.ProcMgrCommandList.includes(cmd)) {
            return "procmgr";
        }
        return undefined;
    }
}
Commands.ProcMgrCommandList = ProcMgr.commands;
